import { useQuery } from '@tanstack/react-query';

import { getRecentActivity } from '../../../api/dashboard';
import { useAuth } from '../../auth/AuthProvider';

export function useRecentActivity(limit = 5) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['recent-activity', limit],
    queryFn: () => getRecentActivity(tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}
